import React from 'react';
import { dataIta } from '../utils/oraItaliana';

/**
 * SegnoOpposizioneTs — «Opposizione al Sistema TS dal gg/mm/aaaa».
 *
 * PERCHE' C'E' (F2, Alex 4/10/2026). L'opposizione che il paziente firma nel
 * modulo della privacy, al tablet o alla postazione, arrivava in archivio ma
 * si vedeva solo nella schermata «Tessera Sanitaria», cioe' a fattura gia'
 * emessa. Adesso sta in testa alla scheda del paziente e in cassa, sul
 * documento che si sta per emettere.
 *
 * DA DOVE VIENE. Il server manda `opposizione_ts_attiva` e
 * `opposizione_ts_dal` (AAAA-MM-GG, il giorno italiano) dalla stessa regola
 * che legge l'invio al Sistema TS (backend/services/opposizioneTs.js). Qui
 * non si decide niente: non si rileggono le colonne grezze della scheda, che
 * sarebbe una seconda copia della regola.
 *
 * E' UN'INFORMAZIONE, NON UN BLOCCO. Con l'opposizione il documento parte
 * lo stesso, senza il codice fiscale del paziente: niente rosso, niente
 * conferma da chiedere. Un'opposizione senza data (la scheda lo permette) si
 * mostra lo stesso, senza la data: sparire mentre l'invio la applica sarebbe
 * peggio.
 */
export const testoOpposizioneTs = (dal) => (dal
    ? `Opposizione al Sistema TS dal ${dataIta(dal)}`
    : 'Opposizione al Sistema TS (data non registrata)');

const SegnoOpposizioneTs = ({ attiva, dal }) => {
    if (attiva !== true) return null;
    return (
        <span className="rm-stato rm-stato-neutro" data-segno="opposizione-ts"
              title="Il paziente si è opposto alla trasmissione delle sue spese al Sistema Tessera Sanitaria: i documenti partono senza il suo codice fiscale.">
            {testoOpposizioneTs(dal)}
        </span>
    );
};

export default SegnoOpposizioneTs;
